/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PageResponseRebatePolicyResponse,
  RebatePoliciesRequest,
  RebatePolicyRequest,
  RebatePolicyResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class RebatePolicies<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags rebate-policy-controller
   * @name Add
   * @request POST:/rebatePolicies
   * @secure
   * @response `200` `RebatePolicyResponse` OK
   */
  add = (data: RebatePolicyRequest, params: RequestParams = {}) =>
    this.request<RebatePolicyResponse, any>({
      path: `/rebatePolicies`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rebate-policy-controller
   * @name List
   * @request POST:/rebatePolicies/getRebatePolicies
   * @secure
   * @response `200` `PageResponseRebatePolicyResponse` OK
   */
  list = (data: RebatePoliciesRequest, params: RequestParams = {}) =>
    this.request<PageResponseRebatePolicyResponse, any>({
      path: `/rebatePolicies/getRebatePolicies`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags rebate-policy-controller
   * @name Show
   * @request GET:/rebatePolicies/{rebatePolicyId}
   * @secure
   * @response `200` `RebatePolicyResponse` OK
   */
  show = (rebatePolicyId: string, params: RequestParams = {}) =>
    this.request<RebatePolicyResponse, any>({
      path: `/rebatePolicies/${rebatePolicyId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags rebate-policy-controller
   * @name DeleteRebatePolicy
   * @request DELETE:/rebatePolicies/{rebatePolicyId}
   * @secure
   * @response `200` `RebatePolicyResponse` OK
   */
  deleteRebatePolicy = (rebatePolicyId: string, params: RequestParams = {}) =>
    this.request<RebatePolicyResponse, any>({
      path: `/rebatePolicies/${rebatePolicyId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags rebate-policy-controller
   * @name Update
   * @request PATCH:/rebatePolicies/{rebatePolicyId}
   * @secure
   * @response `200` `RebatePolicyResponse` OK
   */
  update = (
    rebatePolicyId: string,
    data: RebatePolicyRequest,
    params: RequestParams = {},
  ) =>
    this.request<RebatePolicyResponse, any>({
      path: `/rebatePolicies/${rebatePolicyId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
